/**
 * スタッフスナップの拡大表示（クライアント要望・2026-08-11 / ebine参考）。
 *
 * 一覧のスナップを押すと、そのスナップ用の <template> を複製してモーダルに流し込む。
 * <template> の中身はページのDOMに数えられないので、スナップを何枚足しても
 * 商品ページのDOM量が増えない（トップが1,300要素あるので、ここは増やしたくない）。
 *
 * 守ること:
 *   - JSが動かない環境ではボタンが何も起きないだけ。購入導線には触らない
 *   - 開いている間は背面を固定する（カートドロワー・SPメニューと同じ作法）
 */
(function () {
  var modal = document.querySelector('[data-sk-snap-modal]');
  if (!modal) return;
  var overlay = document.querySelector('[data-sk-snap-overlay]');
  var body = modal.querySelector('[data-sk-snap-body]');
  var opener = null;

  function open(id) {
    var tpl = document.querySelector('[data-sk-snap-tpl="' + id + '"]');
    if (!tpl) return;
    body.textContent = '';
    body.appendChild(tpl.content.cloneNode(true));
    modal.hidden = false;
    overlay.hidden = false;
    document.body.style.overflow = 'hidden';
    // 閉じるボタンにフォーカスを当てると枠が出て目立つので、器のほうを持つ
    modal.setAttribute('tabindex', '-1');
    modal.focus();
  }

  function close() {
    modal.hidden = true;
    overlay.hidden = true;
    body.textContent = '';
    document.body.style.overflow = '';
    if (opener) opener.focus();
  }

  document.addEventListener('click', function (ev) {
    var item = ev.target.closest('[data-sk-snap]');
    if (item) {
      opener = item;
      open(item.getAttribute('data-sk-snap'));
      return;
    }
    if (ev.target.closest('[data-sk-snap-close]') || ev.target.closest('[data-sk-snap-overlay]')) {
      close();
      return;
    }
    // サムネイルで大きい画像を差し替える
    var thumb = ev.target.closest('[data-sk-snap-thumb]');
    if (thumb && modal.contains(thumb)) {
      var big = modal.querySelector('[data-sk-snap-big] img');
      var full = thumb.getAttribute('data-full');
      if (big && full) {
        big.removeAttribute('srcset');
        big.src = full;
      }
      modal.querySelectorAll('[data-sk-snap-thumb]').forEach(function (t) {
        t.classList.toggle('is-on', t === thumb);
      });
    }
  });

  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape' && !modal.hidden) close();
  });
})();
